import { Button } from 'antd';
import { COLOR_OPTIONS, FONT_FAMILY } from 'config/style';
import styled from 'styled-components';

export const CustomSkeleton = styled.div<{ width?: string; height?: string }>`
  width: ${({ width }) => width ?? '100%'};
  height: ${({ height }) => height ?? '20px'};
  background: #f6f7f8;
  background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
  background-repeat: no-repeat;
  background-size: 500px 100%;
  display: inline-block;
  position: relative;
  border-radius: 4px;
`;

export const Container = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.div`
  margin: 16px 16px 12px 16px;
  flex-shrink: 0;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-top: 10px;
`;

export const PestManagementButton = styled(Button).attrs({ type: 'primary', block: true, size: 'large' })`
  font-family: ${FONT_FAMILY};
  font-size: 14px;
`;

export const ManagementButton = styled(Button).attrs({ type: 'link', size: 'small' })`
  color: ${COLOR_OPTIONS.BLUE_60};
  font-family: ${FONT_FAMILY};
`;

export const ListContainer = styled.div`
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const SkeletonListContainer = styled.div`
  padding: 12px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
